export default __webpack_public_path__ + "static/media/slider_mob_3.c08dd613.png";